import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NewTableEditorComponent, NewTableEditorUserViewOptions } from 'new-table-editor';
import { FilterParams, StarbaseComponentMessage, toggleObjInArray } from 'starbase-launcher';
import { Log_ext, LogLevel } from '../models/log-ext';
import { Observable } from 'rxjs';
import { StarbaseComponentMessageService } from '../services/starbase-component-message.service';
import { LogDataService } from '../services/log-data.service';
import { StarbaseLoginService } from 'starbase-login';
import { LogSearchComponent } from '../log-search/log-search.component';

@Component({
  selector: 'app-log-screen',
  templateUrl: './log-screen.component.html',
  styleUrls: ['./log-screen.component.css']
})
export class LogScreenComponent implements OnInit {

  @ViewChild('mainLogs') mainLogsTable: NewTableEditorComponent<any>;
  @ViewChild('logSearch', { static: true }) logSearch: LogSearchComponent;

  showExceptions = false;
  logUserViewOpts = new NewTableEditorUserViewOptions(true);
  logFilterParams = new FilterParams<Log_ext>();
  // eslint-disable-next-line @typescript-eslint/naming-convention
  LogCols = Log_ext.LogColumns();
  currentLogLevelFiltersSet: string[] = [];

  logDataSearch$ = new Observable<FilterParams<Log_ext>>();

  constructor(
    public sbCmpMsgSvc: StarbaseComponentMessageService,
    public logDataSvc: LogDataService,
    @Inject(StarbaseLoginService) private loginSvc: StarbaseLoginService
  ) { }

  get logLevels(): Array<string> {
    const keys = Object.keys(LogLevel);
    return keys.slice(keys.length / 2);
  }

  ngOnInit() {
    this.logFilterParams.addToSorts('id'); // default to latest first sorting
    this.logFilterParams.sortAsc = false;
  }

  toggleExceptions(): void {
    this.showExceptions = !this.showExceptions;
    if (this.showExceptions) {
      if (this.checkAdmin()) {
        this.LogCols = Log_ext.LogColumns(false, true, true);
      } else {
        this.showExceptions = false;
      }
    } else {
      this.LogCols = Log_ext.LogColumns(false, true);
    }
  }

  searchTyping(searchText: string) {
    if (searchText === '') {
      this.logFilterParams.searchPhrase = '';
      this.logFilterParams.explicitSearchProperties = [];
      this.logFilterParams.collection = [];
      this.reloadLogTable();
    } else {
      this.logFilterParams.searchPhrase = searchText;
      this.logFilterParams.explicitSearchProperties = this.logSearch.getEnabledFilterExplicitProperties();
    }
  }

  quickSearchLogs(results: Log_ext[]) {
    try {
      this.logFilterParams.collection = results;
      this.reloadLogTable();
    } catch (e) {
      this.handleSearchError(e);
    }
  }

  handleSearchError(e?: Error | string): void {
    setTimeout(() => {
      this.sbCmpMsgSvc.handleStarbaseComponentMsg(
        StarbaseComponentMessage.messageForUser(
          'Log search error',
          'Something went wrong when applying the search.',
          true
        )
      );
    }, 1);
    console.error(e);
  }

  public reloadLogTable(): void {
    this.logFilterParams.page = 1;
    this.mainLogsTable.dataFilterParams = this.logFilterParams;
    this.mainLogsTable.loadData();
  }

  clearLogLevelFilters(): void {
    this.logFilterParams.replaceFilter('Level', '');
    this.currentLogLevelFiltersSet = [];
    this.reloadLogTable();
  }

  updateLogLevelFilters(ll: LogLevel): void {
    try {
      toggleObjInArray(this.currentLogLevelFiltersSet, ll);
      this.logFilterParams.replaceFilter('Level', '');
      for (const l of this.currentLogLevelFiltersSet) {
        this.logFilterParams.addToFilter('Level', l);
      }
    } catch {
      this.sbCmpMsgSvc.handleStarbaseComponentMsg(
        StarbaseComponentMessage.messageForUser(
          'Filter error',
          'Could not apply Log level filter.',
          true
        )
      );
    }
    this.reloadLogTable();
  }

  private checkAdmin(): boolean {
    return this.loginSvc.getUserModel().isAdmin();
  }

}
